import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { CampaignResource } from './campaignSessionStore';
import { DetailMessage } from './DetailMessage';
import { PrimaryResourceDisplay } from './PrimaryResourceDisplay';
import { SecondaryResourcesPanel } from './SecondaryResourcesPanel';
import { s } from './styles';
import { SuccessMessage } from './SuccessMessage';
import { IAIScheduleSuccessProps, ResourceStatus, ResourceType } from './types';

interface MultiChannelLayoutProps {
	primaryResource: CampaignResource;
	secondaryResources: ResourceStatus[];
	onGenerateResource: (targetType: ResourceType) => void;
	onClose: () => void;
	props?: IAIScheduleSuccessProps;
}

export const MultiChannelLayout: React.FC<MultiChannelLayoutProps> = ({
	primaryResource,
	secondaryResources,
	onGenerateResource,
	onClose,
	props,
}) => {
	const successMessageContent = props ? (
		<SuccessMessage props={props} primaryResourceType={primaryResource.type} />
	) : null;
	const detailMessageContent = props ? (
		<DetailMessage props={props} primaryResourceType={primaryResource.type} />
	) : null;
	const hasSuccessMessage = Boolean(successMessageContent);
	return (
		<div className={css(s.multiChannelContainer)}>
			<div className={css(s.leftSide)}>
				<PrimaryResourceDisplay resource={primaryResource} props={props} showScheduledText={!hasSuccessMessage} />

				<div className={css(s.successCallout)}>
					<div className={css(s.successHeading)}>Success!</div>
					{successMessageContent}
					{detailMessageContent}
					{onClose && (
						<Button variant='primary' styles={[s.closeButton]} onClick={onClose}>
							Close Window
						</Button>
					)}
				</div>
			</div>

			<div className={css(s.rightSide)}>
				<SecondaryResourcesPanel
					primaryType={primaryResource.type}
					secondaryResources={secondaryResources}
					onGenerateResource={onGenerateResource}
				/>
			</div>
		</div>
	);
};
